import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';

export function EmptyChatMessage() {
    return (
        <View style={styles.emptyMessageContainer}>
            <Text>No messages here yet...</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    emptyMessageContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        ...Platform.select({ native: { transform: [{ scaleY: -1 }] } }),
    },
});
